export default __webpack_public_path__ + "static/media/previous_expo_2019 (4).95915bbf.jpg";